import { useContext } from 'react';

import PageDataContext from 'bundles/payments-common/data/PageDataContext';
import type { ContextType } from 'bundles/payments-common/data/PageDataContext';

export type PageDataType = ContextType;

const usePageData = (): PageDataType => {
  const context = useContext(PageDataContext);
  if (!context) {
    throw new Error('Missing PageDataContext. Make sure you wrap your page with a data provider.');
  }
  return context;
};

export default usePageData;
